import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useUserPermission } from "@helpers/userPermissionHelper";
import { OrgLocation } from "@store/locationsSlice";
import { useNavigate } from "react-router-dom";
import { LBtn } from "../../../../../../common/components/LBtn";
import { NavItems } from "../../../../../../common/helpers/navigation";
import { pulse } from "react-animations";
import { styled, keyframes } from "styled-components";

export const LocationCard = ({
    data,
    staffUsers,
    highlight,
    disableButton,
    onEdit
}: LocationCardProps): JSX.Element => {
    const navigate = useNavigate();

    const { isClinicalAdmin } = useUserPermission({ locationId: data.id });

    const handleNavigate = (): void => {
        navigate(`${NavItems.Admin.Manage.LocationDetails.path}?locationId=${data.id}&locationName=${data.name}`);
    };

    return (
        <LocationCardContainer className="box">
            <div className="columns is-align-items-center">
                <div className="column is-one-quarter">
                    <span className="has-text-weight-semibold">{data.name}</span>
                    <div className="is-size-7">{data.addressLine1}</div>
                    <div className="is-size-7">{`${data.addressCity}, ${data.addressState} ${data.addressZipCode}`}</div>
                </div>
                <div className="column is-one-quarter">
                    <div className="is-size-7">Staff Users</div>
                    <div className="has-text-weight-bold is-size-7">{staffUsers}</div>
                </div>
                <div className="column" />
                <div className="column is-one-quarter">
                    {isClinicalAdmin && (
                        <div className="is-flex is-flex-direction-column">
                            <LBtn
                                classes={highlight ? "pulse" : ""}
                                onClick={handleNavigate}
                                isBold
                                fontSize="6h"
                                disabled={disableButton}
                                smallSpacing
                            >
                                {" + Add staff users "}
                            </LBtn>
                            <LBtn variation="unstyled" onClick={onEdit} fontSize="6h" smallSpacing>
                                <FontAwesomeIcon className="px-1" icon={solid("pen-to-square")} /> Edit location details
                            </LBtn>
                        </div>
                    )}
                </div>
            </div>
        </LocationCardContainer>
    );
};

interface LocationCardProps {
    data: OrgLocation;
    staffUsers: number;
    highlight?: boolean;
    disableButton?: boolean;
    onEdit: () => void;
}

const LocationCardContainer = styled.div`
    .pulse {
        animation: 1s ${keyframes`${pulse}`};
        animation-iteration-count: infinite;
    }
`;
